(function () {
	'use strict';

	angular
    .module('app.setup')
    .controller('workbenchCustomerConfig', workbenchCustomerConfig);

	workbenchCustomerConfig.$inject = ['$rootScope', '$scope', '$timeout', '$experiments'];

	function workbenchCustomerConfig($rootScope, $scope, $timeout, $experiments) {
		var vm = this;

		$scope.siteId = globalConfig.factory.id;
		$scope.customerId = globalConfig.customer.id;
	}
})();